import {
  createUnavailabilityError,
  CreateUnavailabilityError,
  Unavailability,
} from "@planzone/dto";
import { DateOps } from "../adapters/dateOps";

function hasDate(date: string): boolean {
  return date.length > 0;
}

function isDateRangeValid(
  dateOps: DateOps,
  startDate: string,
  endDate: string,
): boolean {
  return (
    !hasDate(startDate) ||
    !hasDate(endDate) ||
    dateOps.isAfterOrEqual(endDate, startDate)
  );
}

function validateUnAvailability(
  dateOps: DateOps,
  unavailability: Unavailability,
): CreateUnavailabilityError {
  return {
    ...createUnavailabilityError,
    emptyName: unavailability.label === "",
    invalidResource: unavailability.resource.uuid === "",
    invalidReason: unavailability.reason.uuid === "",
    invalidStartDate: !dateOps.isValidUtcIso(unavailability.startDate),
    invalidDateRange:
      unavailability.endDate !== undefined &&
      !isDateRangeValid(
        dateOps,
        unavailability.startDate,
        unavailability.endDate,
      ),
  };
}

export { validateUnAvailability };
